let injected = false;

/**
 * Injects CSS fixes for Monaco editor UI.
 * Covers codicon font-family for folding chevrons, general codicon fallback,
 * suggest-widget icons, and a pointer-events fix that stops Find-widget button
 * tooltips (Close, Find In Selection, etc.) from flickering.
 * Safe to call multiple times — only injects once.
 */
export function injectMonacoStyleFixes(): void {
  if (injected) return;
  injected = true;

  const style = document.createElement("style");
  style.textContent = `
    .monaco-editor .codicon-chevron-down::before,
    .monaco-editor .codicon-chevron-right::before {
      font-family: codicon !important;
      font-size: 16px !important;
      line-height: 16px !important;
    }
    .monaco-editor .codicon-chevron-down::before {
      content: "\\eab4" !important;
    }
    .monaco-editor .codicon-chevron-right::before {
      content: "\\eab6" !important;
    }
    .monaco-editor .codicon::before {
      font-family: codicon !important;
      font-size: 16px !important;
      line-height: 16px !important;
    }
    .monaco-editor .suggest-widget {
      font-size: 14px !important;
    }
    .monaco-editor .suggest-widget .monaco-list .monaco-list-row .suggest-icon {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: 16px !important;
      height: 16px !important;
    }
    .monaco-editor .suggest-widget .monaco-list .monaco-list-row .suggest-icon::before {
      font-family: codicon !important;
      font-size: 16px !important;
      line-height: 16px !important;
    }
    .monaco-editor .suggest-widget .monaco-list .monaco-list-row .suggest-icon.codicon-symbol-method::before {
      content: "\\ea8c" !important;
    }
    .monaco-editor .suggest-widget .monaco-list .monaco-list-row .suggest-icon.codicon-symbol-class::before {
      content: "\\ea83" !important;
    }
    .monaco-editor .suggest-widget .monaco-list .monaco-list-row .suggest-icon.codicon-symbol-interface::before {
      content: "\\ea8b" !important;
    }
    .monaco-editor .suggest-widget .monaco-list .monaco-list-row .suggest-icon.codicon-symbol-module::before {
      content: "\\ea7f" !important;
    }
    .monaco-editor .suggest-widget .monaco-list .monaco-list-row .suggest-icon.codicon-symbol-property::before {
      content: "\\ea8a" !important;
    }
    .monaco-editor .suggest-widget .monaco-list .monaco-list-row .suggest-icon.codicon-symbol-enum::before {
      content: "\\ea95" !important;
    }
    .monaco-editor .suggest-widget .monaco-list .monaco-list-row .suggest-icon.codicon-symbol-struct::before {
      content: "\\ea91" !important;
    }

    /*
      Fix tooltip flicker on Find-widget buttons (Close, Find In Selection,
      Prev/Next Match, etc).
    */
    .context-view:has(.workbench-hover-container) {
      pointer-events: none !important;
    }
    .monaco-hover {
      animation: none !important;
    }
  `;
  document.head.appendChild(style);
}
